import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=ee24ffc0&scoped=true"
import script from "./Confirmation.vue?vue&type=script&lang=js"
export * from "./Confirmation.vue?vue&type=script&lang=js"
import style0 from "./Confirmation.vue?vue&type=style&index=0&id=ee24ffc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee24ffc0",
  null
  
)

export default component.exports